import React, { useState } from 'react';
import { LogIn } from 'lucide-react';
import './GarageLogin.css';

const GarageLogin = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSSOLogin = () => {
    setIsLoading(true);
    localStorage.setItem('saml_login_attempt_time', Date.now().toString());

    const relayState = encodeURIComponent(window.location.origin);
    window.location.href = `/api/v1/auth/saml/login?relay_state=${relayState}`;
  };

  return (
    <main className="garage-login">
      <div className="garage-login-shape garage-login-shape-one" aria-hidden="true" />
      <div className="garage-login-shape garage-login-shape-two" aria-hidden="true" />

      <section className="garage-login-card" aria-labelledby="garage-login-title">
        <div className="garage-login-mark">
          <img src="/ai-garage-icon.png" alt="AI Garage" />
        </div>
        <h1 id="garage-login-title">AI Garage</h1>
        <p className="garage-login-subtitle">Discover, build, and manage AI tools</p>
        <p className="garage-login-description">
          Sign in with your organization account to continue.
        </p>

        <button
          type="button"
          className="garage-login-button"
          onClick={handleSSOLogin}
          disabled={isLoading}
          aria-busy={isLoading}
        >
          {isLoading ? (
            <>
              <span className="garage-login-spinner" aria-hidden="true" />
              Redirecting to SSO…
            </>
          ) : (
            <>
              <LogIn size={20} />
              Sign in with SSO
            </>
          )}
        </button>
      </section>
    </main>
  );
};

export default GarageLogin;
